// Flags are the com.diagnocat.auth.AdminPermissions proto fields, arranged
// into the logical groups the Access panel renders.
export const ADMIN_PERMISSION_GROUPS = [
  {
    key: 'apiKeys',
    flags: ['APIKeyCanView', 'APIKeyCanDelete', 'APIKeyCanCreate'],
  },
  {
    key: 'systemLoad',
    flags: ['SystemLoadCanView', 'SystemLoadCanChange'],
  },
  {
    key: 'adminAccess',
    flags: ['BasicAccess', 'AdminPermissionsCanView', 'AdminPermissionsCanEdit'],
  },
  {
    key: 'twoStepVerification',
    flags: [
      'MFACanView',
      'MFACanEnforce',
      'MFACanSetup',
      'MFACanEditAdmin',
    ],
  },
  {
    key: 'other',
    flags: [
      'FeatureFlagsCanEdit',
      'BillingCanEditInventory',
      'BillingZoneCanEdit',
      'DistributorsCanManage',
      'DSOCanManage',
      'StatisticsCanViewForAllOrganization',
    ],
  },
] as const;

export const ADMIN_PERMISSION_FLAGS = ADMIN_PERMISSION_GROUPS.flatMap(
  (group) => group.flags,
);
